import { Attributes, ModelBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class MemberFindCriteria extends ModelBase {

    @Attributes.Display("Add Member")
    public addUserId : number | null = null;
}